import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { navigate } from "@reach/router";
import Container from "react-bootstrap/Container";
import CHEFS from "assets/icons/chefs.svg";
import DANCERS from "assets/icons/dancers.svg";
import DESIGNERS from "assets/icons/designers.svg";
import PROGRAMMERS from "assets/icons/programmers.svg";
import TEACHERS from "assets/icons/teachers.svg";
import TICK_BG from "assets/icons/tick_bg.svg";
import TICK_MONO from "assets/icons/tick_mono.svg";
import TRAINERS from "assets/icons/trainers.svg";
import WEBSITE_ICON from "assets/icons/website.svg";
import YOGIS from "assets/icons/yogis.svg";

import "./home.scss";

function Home() {
  return (
    <Container fluid className="container-main">
      {/* Hero Section */}
      <Container className="container-hero">
        <Col md={6} xl={true} className="container-cta-hero-fc">
          <p className="heading-hero text-hero-fc">For Creators</p>
          <p className="sub-heading-hero text-hero-fc">
            Build and sell live classes, courses and subscriptions - no coding,
            no hiring, no learning curve.
          </p>
          <div className="container-value-prop-item-fc">
            <img src={TICK_BG} alt="tick bullet" className="icon-tick-fc" />
            <p className="text-hero-fc text">Live streaming</p>
          </div>
          <div className="container-value-prop-item-fc">
            <img src={TICK_BG} alt="tick bullet" className="icon-tick-fc" />
            <p className="text-hero-fc text">On demand</p>
          </div>
          <div className="container-value-prop-item-fc">
            <img src={TICK_BG} alt="tick bullet" className="icon-tick-fc" />
            <p className="text-hero-fc text">Class schedule</p>
          </div>
          <div className="container-value-prop-item-fc">
            <img src={TICK_BG} alt="tick bullet" className="icon-tick-fc" />
            <p className="text-hero-fc text">Wide audience</p>
          </div>
          <div className="container-value-prop-item-fc">
            <img src={TICK_BG} alt="tick bullet" className="icon-tick-fc" />
            <p className="text-hero-fc text">Simple payments</p>
          </div>
          <Button
            className="button-become-creator-hero"
            buttonText="Get started for free"
            buttonOnClick={() => navigate("/teach")}
          />
        </Col>
        <Col className="container-img-hero align-self-center mw-100">
          <img
            className="img-hero"
            alt="tick bullet"
            src="/illustrations/hero_image.svg"
          />
        </Col>
        <Col md={6} xl={true} className="container-cta-hero-fl">
          <p className="heading-hero text-hero-fl">For Learners</p>
          <p className="sub-heading-hero text-hero-fl">
            Train live with the best of instructors from over the world. Try
            thousands of classes. All in one app.
          </p>
          <div className="container-value-prop-item-fl">
            <img src={TICK_MONO} alt="tick bullet" className="icon-tick-fl" />
            <p className="text-hero-fl text">Learn anything anywhere LIVE</p>
          </div>
          <div className="container-value-prop-item-fl">
            <img src={TICK_MONO} alt="tick bullet" className="icon-tick-fl" />
            <p className="text-hero-fl text">Get real time feedback</p>
          </div>
          <div className="container-value-prop-item-fl">
            <img src={TICK_MONO} alt="tick bullet" className="icon-tick-fl" />
            <p className="text-hero-fl text">Learn with 200+ master trainers</p>
          </div>
          <div className="container-value-prop-item-fl">
            <img src={TICK_MONO} alt="tick bullet" className="icon-tick-fl" />
            <p className="text-hero-fl text">Learn together with friends</p>
          </div>
          <div className="container-value-prop-item-fl">
            <img src={TICK_MONO} alt="tick bullet" className="icon-tick-fl" />
            <p className="text-hero-fl text">Talk to trainers directly</p>
          </div>
          <Button
            className="button-start-now"
            buttonText="Try out for free"
            buttonOnClick={() => navigate("/learn")}
          />
        </Col>
      </Container>
      <div className="separator-horizontal-wia separator-horizontal"></div>
      {/* Value Proposition Section */}
      <Container className="container-value-prop">
        <Row>
          <Col lg={5} className="align-self-center">
            <p className="section-heading-wia section-heading">
              What is Edify?
            </p>
            <p className="text">
              <b>For creators</b>, Edify is everything you need to create,
              market and sell live and on-demand content - classes, courses,
              subscriptions, memberhsips and payments.
            </p>
            <Row className="row-container-fc-people-start">
              <Col sm={6} className="container-fc-people-start">
                <img
                  src={TRAINERS}
                  alt="icon for creators"
                  className="icon-for-creators"
                  height="40px"
                />
                <p className="text-fc text">For trainers</p>
              </Col>
              <Col sm={6} className="container-fc-people-end">
                <img
                  src={PROGRAMMERS}
                  alt="icon programmers"
                  className="icon-for-creators"
                  height="40px"
                />
                <p className="text-fc text">For programmers</p>
              </Col>
            </Row>
            <Row className="row-container-fc-people-start">
              <Col sm={6} className="container-fc-people-start">
                <img src={CHEFS} alt="icon chefs" className="icon-for-creators" height="40px" />
                <p className="text-fc text">For chefs</p>
              </Col>
              <Col sm={6} className="container-fc-people-end">
                <img src={YOGIS} alt="icon yogis" className="icon-for-creators" height="40px" />
                <p className="text-fc text">For yogis</p>
              </Col>
            </Row>
            <Row className="row-container-fc-people-start">
              <Col sm={6} className="container-fc-people-start">
                <img
                  src={DANCERS}
                  alt="icon dancers"
                  className="icon-for-creators"
                  height="40px"
                />
                <p className="text-fc text">For dancers</p>
              </Col>
              <Col sm={6} className="container-fc-people-end">
                <img
                  src={DESIGNERS}
                  alt="icon designers"
                  className="icon-for-creators"
                  height="40px"
                />
                <p className="text-fc text">For designers</p>
              </Col>
            </Row>
            <Row className="row-container-fc-people-start">
              <Col sm={6} className="container-fc-people-start">
                <img
                  src={TEACHERS}
                  alt="icon teachers"
                  className="icon-for-creators"
                  height="40px"
                />
                <p className="text-fc text">For teachers</p>
              </Col>
              <Col sm={6} className="container-fc-people-end">
                <p className="text-fc text">And everyone else...</p>
              </Col>
            </Row>
            <br />
            <br />
            <p className="text">
              <b>For learners</b>, Edify lets you try thousands of live and
              on-demand classes and courses - from strength and conditioning, to
              slow burn yoga, to classical dance, to manning a drone.
            </p>
          </Col>
          <Col lg={7} className="container-masonry">
            <img
              src="/images/become-trainer-1.jpeg"
              className="img-masonry image img-masonry-1"
            />
            <img
              src="/images/become-trainer-2.jpeg"
              className="img-masonry image img-masonry-2"
            />
            <img
              src="/images/become-trainer-3.jpeg"
              className="img-masonry image img-masonry-3"
            />
            <img
              src="/images/become-trainer-4.jpeg"
              className="img-masonry image img-masonry-4"
            />
            <img
              src="/images/become-trainer-5.jpeg"
              className="img-masonry image img-masonry-5"
            />
            <img
              src="/images/become-trainer-6.jpeg"
              className="img-masonry image img-masonry-6"
            />
            <img
              src="/images/become-trainer-7.jpeg"
              className="img-masonry image img-masonry-7"
            />
            <img
              src="/images/become-trainer-8.jpeg"
              className="img-masonry image img-masonry-8"
            />
            <img
              src="/images/become-trainer-9.jpeg"
              className="img-masonry image img-masonry-9"
            />
            <img
              src="/images/become-trainer-10.jpeg"
              className="img-masonry image img-masonry-10"
            />
            <img
              src="/images/become-trainer-11.jpeg"
              className="img-masonry image img-masonry-11"
            />
            <img
              src="/images/become-trainer-12.jpeg"
              className="img-masonry image img-masonry-12"
            />
            <img
              src="/images/become-trainer-13.jpeg"
              className="img-masonry image img-masonry-13"
            />
            <img
              src="/images/become-trainer-14.jpeg"
              className="img-masonry image img-masonry-14"
            />
          </Col>
        </Row>
      </Container>
      <div className="separator-horizontal"></div>
      {/* For Creators Section */}
      <Container className="container-for-creators">
        <p className="section-heading section-heading-for-creators">
          For Creators
        </p>
        {/* Value Propositions */}
        <Container fluid>
          <Row className="row-value-prop-fc justify-content-center">
            {/* Start Earning */}
            <Col sm={12} md={4}>
              <p className="text-fc-value-prop">Start earning with Edify</p>
              <img
                src="/illustrations/earn_money.svg"
                alt="starting earning money"
                className="img-value-prop-fc"
              />
            </Col>
            {/* Reach wider audience */}
            <Col sm={12} md={4}>
              <p className="text-fc-value-prop">Reach wider audience</p>
              <img
                src="/illustrations/wider_audience.svg"
                alt="reach wider audience"
                className="img-value-prop-fc"
              />
            </Col>
            {/* Get Certified */}
            <Col sm={12} md={4}>
              <p className="text-fc-value-prop">2 way live streaming classes</p>
              <img
                src="/illustrations/two-way-stream.svg"
                alt="two way streaming"
                className="img-value-prop-fc"
              />
            </Col>
            <Col sm={12} md={4}>
              <p className="text-fc-value-prop">Single payments</p>
              <img
                src="/illustrations/single-payment.svg"
                alt="single payments"
                className="img-value-prop-fc"
              />
            </Col>
            <Col sm={12} md={4}>
              <p className="text-fc-value-prop">Automated reminders and timetable</p>
              <img
                src="/illustrations/automated-reminder.svg"
                alt="automated reminders"
                className="img-value-prop-fc"
              />
            </Col>
          </Row>
        </Container>
        {/* Get Started - For Creators */}
        <Container>
          <p className="section-sub-heading">Get Started</p>
          <Row>
            <Col lg={3} className="col-get-started-fc align-self-center">
              <img
                src="/images/become-trainer.jpeg"
                alt="become trainer"
                className="img-become-trainer image"
              />
            </Col>
            <Col lg={4} className="col-get-started-fc align-self-center">
              <p className="text-become-trainer text">
                Become a creator today. It only takes 5 mins to apply and get on
                boarded with us. Start your application process by clicking on
                the button below.
              </p>
              <Button
                className="button-become-creator-fc"
                buttonText="Become a Creator"
                buttonOnClick={() => navigate("/teach")}
              />
            </Col>
            <div className="separator-get-started-for-creators"></div>
            <Col lg={4} className="col-get-started-fc align-self-center">
              <p className="text-get-started-trainers text">
                Start on one of our platforms
              </p>
              <img
                className="button-android-trainer button-android"
                alt="play store button for creators"
                src="/play-store.jpeg"
                width="200px"
              />
              <img
                className="button-ios-trainer button-ios"
                alt="app store button for creators"
                src="/apple-image.svg"
                width="200px"
              />
              <ButtonWithIcon
                className="button-web-trainer button-web button"
                buttonText="Start on Web"
                buttonIcon={WEBSITE_ICON}
                iconHeight="30px"
                buttonOnClick={() => navigate("/teach")}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="separator-horizontal"></div>
      {/* For Learners Section */}
      <p className="section-heading section-heading-for-learners">
        For Learners
      </p>
      <p className="text-for-learners text">
        The master of hand lettering? Aristotle of coding? Authority on flying
        drones? Learn anything. <br />
        From the most inspiring coaches from all over the world. Try thousands
        of classes from harder-than-life physical bootcamp, to slow yoga, to
        classical dance. All in one app.
      </p>
      <Container className="container-for-learners">
        <Row>
          <Col xl={4} className="align-self-center">
            <img
              className="img-become-learner image"
              alt="become learner"
              src="/images/become-student.jpeg"
            />
            <div className="container-pricing">
              <p id="text-helper-pricing" className="text">
                Starting just
              </p>
              <p id="text-pricing" className="text">
                ₹100/month
              </p>
            </div>
          </Col>
          <Col xl={7} className="container-value-props-fl align-items-end">
            <Row>
              <Col className="container-value-prop-fl-1">
                <p className="text-fl-value-prop">Learn absolutely anywhere</p>
                <img
                  className="img-value-prop-fl"
                  alt="learn anywhere"
                  src="/illustrations/learn-anywhere.svg"
                />
              </Col>
              <Col className="container-value-prop-fl-2">
                <p className="text-fl-value-prop">Learn live with 200+ trainers</p>
                <img
                  className="img-value-prop-fl"
                  alt="learn with trainer"
                  src="/illustrations/learn-trainers.svg"
                />
              </Col>
            </Row>
            <Row>
              <Col className="container-value-prop-fl-3">
                <p className="text-fl-value-prop">Get real-time feedback</p>
                <img
                  className="img-value-prop-fl"
                  alt="real-time feedback"
                  src="/illustrations/real-time-feedback.svg"
                />
              </Col>
              <Col className="container-value-prop-fl-4">
                <p className="text-fl-value-prop">Work out with friends</p>
                <img
                  className="img-value-prop-fl"
                  alt="work out with friends"
                  src="/illustrations/work-out-friends.svg"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {/* Get Started Section */}
      <Container className="container-get-started-fl">
        <p className="section-sub-heading">Get Started Today</p>
        <Row>
          <Col sm={12} lg={6} className="align-self-center">
            <p className="text-get-started-fl text">
              Transform your life through learning. Top instructors from around
              the world teach thousands of students on Edify. Try a free class
              now to start your journey.
              <br /> <br />
              <b>Be better everyday. Learn a little.</b>
            </p>
          </Col>
          <Col sm={12} lg={6}>
            <img
              className="button-android-learner button-android"
              alt="play store button for learners"
              src="/play-store.jpeg"
              width="200px"
            />
            <img
              className="button-ios-learner button-ios"
              alt="play store button for learners"
              src="/apple-image.svg"
              width="200px"
            />
            <ButtonWithIcon
              className="button-web-learner button-web button"
              buttonOnClick={() => navigate("/learn")}
              buttonText="Start on Web"
              buttonIcon={WEBSITE_ICON}
              iconHeight="30px"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home;

// Local Component for Button.
const Button = (props) => {
  return (
    <button
      className={`button ` + props.className}
      onClick={props.buttonOnClick}
    >
      {props.buttonText}
    </button>
  );
};

// Local Component for Button With Icon.
const ButtonWithIcon = (props) => {
  return (
    <button
      className={`button ` + props.className}
      onClick={props.buttonOnClick}
      width={props.width}
    >
      <img
        src={props.buttonIcon}
        alt=""
        width={props.iconWidth}
        height={props.iconHeight}
      />
      <p className="text-button">{props.buttonText}</p>
    </button>
  );
};
